<template>
  <div
    :class="wrapperClass ? `${wrapperClass} a-avatar-edition` : 'a-avatar-edition'"
  >
    <span
      :class="`a-avatar-primary a-avatar-${avatarClass} margin-right-medium`"
      href="#"
    >
      <img
        v-if="avatar.image"
        key="avatarImage"
        :src="avatar.image"
      >
      <img
        v-else
        key="defaultImage"
        src="@/assets/img/avatar.png"
      >
    </span>
    <span class="display-flex-column font-weight-light margin-zero">
      <span><b>{{ avatar.firstext }}</b></span>
      <span class="text-color-primary-80 margin-top-small">
        {{ avatar.secondtext }}
        <i
          v-if="avatar.icon"
          :class="`${avatar.icon}`"
        />
      </span>
    </span>
  </div>
</template>

<script>
export default {
  name: 'AtomAvatarEquipo',

  props: {
    avatarClass: {
      type: String,
      default: 'small'
    },
    avatar: Object,
    wrapperClass: String
  }
}
</script>
